import { render, staticRenderFns } from "./coin-report.vue?vue&type=template&id=97519232&"
import script from "./coin-report.vue?vue&type=script&lang=js&"
export * from "./coin-report.vue?vue&type=script&lang=js&"
import style0 from "./coin-report.vue?vue&type=style&index=0&id=97519232&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports